// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"8ae2fd00","488":"80a3fd59","489":"63bb4600","796":"d36d3869"}[chunkId] + ".chunk.js";
};